const initialState = {
  stats: null,
  loading: false,
  error: null,
};

export const buyerDashboardStats = (state = initialState, action) => {
  switch (action.type) {
    case "GET_BUYER_DASHBOARD_STATS":
      return { ...state, stats: action.payload, loading: false, error: null };
    case "GET_BUYER_DASHBOARD_STATS_FAILURE":
      return { ...state, loading: false, error: action.error };
    case "BUYER_DASHBOARD_STATS_LOADING":
      return { ...state, loading: true };
    default:
      return state;
  }
};
